import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Variation } from 'lib/ablyft';
import {
  useQualification,
  withQualificationProvider,
} from 'qualification/context';
import { QUALIFICATION_STATUS } from 'qualification/context/model';
import {
  getInitialFunnelDataFromQueryStrings,
  getQueryParamsWithoutAnswers,
} from 'qualification/helpers/parseSearchParams';

function Start() {
  const { actions, state } = useQualification();

  const router = useRouter();

  const {
    query: { reorder_offer_id },
  } = router;

  if (reorder_offer_id && !state.reorderOfferId) {
    actions.setReorderOfferId(reorder_offer_id);
  }

  useEffect(() => {
    const initialize = async () => {
      const variations: Variation[] = [];
      const initializedData = await getInitialFunnelDataFromQueryStrings();

      actions.initialize({
        ...initializedData,
        variations,
      });
    };
    actions.reset();
    initialize();
  }, []);

  useEffect(
    function handleRedirect() {
      if (state.status === QUALIFICATION_STATUS.answering) {
        const queryParams = getQueryParamsWithoutAnswers();

        router.replace({
          pathname: router.pathname + '/' + state.qualification.step.id,
          query: queryParams,
        });
      }
    },
    [state, router]
  );

  return null;
}

export default withQualificationProvider(
  { storageKey: '__funnel', storage: 'sessionStorage' },
  Start
);
